import React from 'react';
import ReactDOM from 'react-dom/client';

// Importar Tailwind CSS (directivas)
import './tailwind.css';

// Importar estilos personalizados después
import './index.css';

import App from './App';

// Verificar si hay una preferencia guardada
const savedDarkMode = localStorage.getItem('darkMode') === 'true';

// Aplicar tema claro por defecto, a menos que esté explícitamente guardado como oscuro
document.body.classList.add(savedDarkMode ? 'dark' : 'light');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
